import { render, staticRenderFns } from "./Vehicle.vue?vue&type=template&id=6444eb44&scoped=true"
import script from "./Vehicle.vue?vue&type=script&lang=js"
export * from "./Vehicle.vue?vue&type=script&lang=js"
import style0 from "./Vehicle.vue?vue&type=style&index=0&id=6444eb44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6444eb44",
  null
  
)

export default component.exports